<template>
  <div>
    <a-upload name="file" :multiple="false" :showUploadList="false" :customRequest="handleChange">
      <a-button :loading="loading" type="primary"><a-icon type="upload" />{{$t('page_ops_machine_upload_file')}}</a-button>
    </a-upload>
    <ml-table :columns="columns" :data-source="data"></ml-table>
  </div>
</template>

<script>
import { postFileAttach } from '@/api/api'
export default {
  data() {
    return {
      loading: false,
      data: [],
      columns: [
        {
          title: this.$t('page_ops_machine_operate'),
          dataIndex: 'key',
          key: 'key',
          width: 110,
          customRender: (row) => {
            return (
              <div style="">
                <a
                  type="link"
                  onClick={(e) => {
                    e.stopPropagation()
                    this.openRegisterDialog(row)
                  }}
                >
                  {this.$t('page_ops_machine_open')}
                </a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title={this.$t('page_resource_pool_confirm_delete')}
                  onConfirm={() => this.deleteSingleData(row)}
                  okText={this.$t('yes')}
                  cancelText={this.$t('no')}
                >
                  <a type="link" onClick={(e) => e.stopPropagation()} class="del-color">
                    {this.$t('delete')}
                  </a>
                </a-popconfirm>
              </div>
            )
          }
        },
        {
          title: this.$t('page_ops_machine_file_name'),
          dataIndex: 'originalName',
          key: 'originalName',
          ellipsis: true
        }
      ],
      count: 0
    }
  },
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fileList: {
      handler() {
        if (this.fileList && this.fileList.length) {
          this.data = this.fileList.map((res, index) => {
            const value = { ...res }
            value.attachId = res.id
            value.key = index + ''
            return value
          })
          this.count = this.fileList.length
          this.$emit('saveList', this.data)
        }
      }
    }
  },
  methods: {
    openRegisterDialog(key) {
      const newData = [...this.data]
      const data = newData.find((res) => res.key === key)
      window.open(data.link)
    },
    deleteSingleData(key) {
      const newData = [...this.data]
      this.data = newData.filter((res) => res.key !== key)
      this.$emit('saveList', this.data)
    },
    handleChange(file) {
      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      postFileAttach(formData).then(
        (res) => {
          if (res) {
            console.log(res)
            const value = { ...res.data.data }
            value.key = this.count + ''
            this.data = this.data.concat(value)
            this.count += 1
            this.$emit('saveList', this.data)
            this.loading = false
          }
        },
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
